var _templateObject = _taggedTemplateLiteralLoose(['\n  .reactGiphySearchbox-message {\n    margin: 0;\n  }\n'], ['\n  .reactGiphySearchbox-message {\n    margin: 0;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

/* eslint-disable import/prefer-default-export */
import { css } from '../../style';

export var styles = css(_templateObject);